<template>
  <div class="imageBox" v-if="url" :class="{ detail: type === 'detail' }">
    <el-image
      v-for="(item, index) in imgList"
      :key="index"
      :src="item"
      class="img"
      fit="cover"
      :preview-src-list="previewSrcList"
    />
    <div class="sum" v-show="sum > 5" v-if="type !== 'detail'">共{{ sum }}张</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    url: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
   preview:{
     type: Boolean,
     default: true
   }
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    images() {
      if (this.url) {
        return this.url.split(",");
      }
      return [];
    },
    imgList() {
      if(this.type==='detail') return this.images
      return this.images.slice(0, 5);
    },
    sum() {
      return this.images.length;
    },
    previewSrcList() {
      if(this.preview){
        return this.images
      }
      return []
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.imageBox {
  height: 90px;
  display: flex;
  gap: 4px;
  position: relative;
  margin-top: 8px;
  .img {
    width: 90px;
    height: 90px;
    border-radius: 4px;
  }
  .sum {
    width: 60px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba($color: #000000, $alpha: 0.5);
    border-radius: 0 4px 4px 0;
  }
}
.detail {
  all: unset;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 两列 */
  grid-template-rows: repeat(3, auto); /* 两行 */
  gap: 8px; /* 同时设置 row-gap 和 column-gap 为 16px */
  .img {
    width: 100%;
    height: auto;
    aspect-ratio: 1/1;
    border-radius: 4px;
  }
}
</style>
